import { FC } from "react";
import { CardContainer, Img, StyledButton } from "./styles";
import { Typography } from "@mui/material";
import { COLORS } from "@/constants";
import { ArrowRight } from "@/components";
import { CardBox } from "./styles";

export interface CardType {
  imgDesktop: string;
  imgMobile: string;
  title: {
    text: string;
    color: keyof typeof COLORS;
  };
  desc: string;
  button: {
    text: string;
    color: keyof typeof COLORS;
    borderColor: keyof typeof COLORS;
  };
}

type CardProps = {
  data: CardType;
};

export const Card: FC<CardProps> = ({ data }) => (
  <CardContainer>
    <CardBox>
      <Typography fontSize={24} fontWeight={700} color={COLORS[data.title.color]}>
        {data.title.text}
      </Typography>
      <Typography fontSize={16} fontWeight={500} color={COLORS["blue"]}>
        {data.desc}
      </Typography>

      <StyledButton
        $color={data?.button?.color}
        $borderColor={data?.button?.borderColor}
        variant="outlined"
        endIcon={
          <ArrowRight
            width={14}
            height={14}
            stroke={COLORS[data?.button?.borderColor]}
            fill={COLORS[data?.button?.borderColor]}
          />
        }
      >
        <Typography fontSize={14} fontWeight={600} textTransform={"none"}>
          {data.button.text}
        </Typography>
      </StyledButton>
    </CardBox>
    <Img>
      <picture>
        <source media="(max-width: 800px)" srcSet={data.imgMobile} />
        <img src={data.imgDesktop} alt="promo-img" />
      </picture>
    </Img>
  </CardContainer >
);
